import {
  FileUploadOutlined,
  TurnLeft,
  UploadFile,
  UploadFileOutlined,
} from "@mui/icons-material";
import { Button, Input } from "@mui/material";
import React, { useState, useEffect, useRef, useContext } from "react";
import styles from "./fieldsStats.module.css";
import { store } from "../contexts/store";
import turf from "turf";
import { setFeature, setUploadFeature } from "../contexts/actions";
const FileUpload = ({ label }) => {
  const {
    state: { feature, location },
    dispatch,
  } = useContext(store);

  const handleInputClick = async (e) => {
    if (e.target.files[0]) {
      const file = JSON.parse(await e.target.files[0].text());
      // console.log(file.type);
      if (file.type === "FeatureCollection" || file.type === "Feature") {
        dispatch({
          type: setUploadFeature,
          payload: { uploadFeature: file },
        });
      }
    }
  };

  return (
    <div className={styles.fileUploadContainer}>
      <Input
        type="file"
        id="fileElem"
        accept=".json,.geojson"
        className={styles.hiddenInput}
        onChange={handleInputClick}
      />
      <label for="fileElem" className={styles.fileUploadLabel}>
        <UploadFileOutlined /> {label}
      </label>
    </div>
  );
};

export default FileUpload;
